export enum DocumentCategories {
    MedCertDocumentation = -1,
    ReasonableAccommodationRequest = -2,
    ReturnToWorkDocumentation = -3,
    Other = -4
}